import React, { useState } from "react";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Button from "../../../../componentsv2/Button";
import Paper from "../../../../componentsv2/Paper";

import GridContainer from "../../../../componentsv2/GridContainer";
import GridItem from "../../../../componentsv2/GridItem";
import Header from "../../../../components/Header";
import Container from "../../../../componentsv2/Container";
import { Input } from "../../../../componentsv2/Input";
import SelectEstado from "../../../../componentsv2/SelectEstado";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { enqueueSnackbar } from "notistack";
import { api } from "../../../../services/Api";

export default function FormularioMedico() {
  const history = useHistory();
  const location = useLocation();
  const care = location?.state;

  const [nome, setNome] = useState("");
  const [crm, setCrm] = useState("");
  const [estado, setEstado] = useState("");
  const [especialidade, setEspecialidade] = useState("");

  const handleNavigate = () => {
    if (care) {
      return history.push("/agendaCare/formularioAgendamento");
    }
    history.push("/agendaCare");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = {
        nome,
        crm,
        estado,
        especialidade,
      };
      await api.post("/v2/agendaCare/create_medico_care", data);
      handleNavigate();
      enqueueSnackbar("Médico cadastrado com sucesso!.", {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar("Erro! Não foi possível cadastrar o médico.", {
        variant: "error",
      });
    }
  };

  return (
    <>
      <Header titulo={"Cadastrar Médico"} />
      <Container>
        <Paper
          style={{
            padding: "1rem",
            alignItems: "center",
            display: "flex",
            justfyContent: "center",
            marginTop: "10px",
          }}
          elevation={2}
        >
          <form
            onSubmit={handleSubmit}
            style={{ width: "99%", display: "flex", flexDirection: "column" }}
          >
            <GridContainer>
              <Button>
                <ArrowBackIcon
                  style={{ color: "#003399" }}
                  onClick={() => history.push({ pathname: "/agendaCare" })}
                />
              </Button>
            </GridContainer>
            <GridContainer sx={{ margin: "1px" }} spacing={2} xs={12}>
              <GridItem xs={12} sm={4} md={5}>
                <Input
                  required
                  fullWidth
                  label="Nome"
                  type="text"
                  variant="standard"
                  onChange={(e) => setNome(e.target.value)}
                  value={nome}
                />
              </GridItem>
              <GridItem xs={12} sm={4} md={5}>
                <Input
                  required
                  fullWidth
                  label="Especialidade"
                  type="text"
                  variant="standard"
                  onChange={(e) => setEspecialidade(e.target.value)}
                  value={especialidade}
                />
              </GridItem>
              <GridItem xs={12} sm={4} md={5}>
                <Input
                  required
                  fullWidth
                  label="CRM"
                  type="text"
                  variant="standard"
                  onChange={(e) => setCrm(e.target.value)}
                  value={crm}
                />
              </GridItem>
              <GridItem xs={12} md={5}>
                <SelectEstado
                  required
                  onChange={(e) => setEstado(e.target.value)}
                  value={estado}
                />
              </GridItem>
            </GridContainer>
            <GridContainer
              item
              sx={{ marginTop: "30px" }}
              justifyContent="flex-end"
              spacing={2}
            >
              <GridItem>
                <Button
                  color="red"
                  variant="outlined"
                  onClick={() => history.push({ pathname: "/agendaCare" })}
                >
                  Cancelar
                </Button>
              </GridItem>
              <GridItem>
                <Button
                  id="agendarButton"
                  type="submit"
                  color="green"
                  variant="contained"
                >
                  Cadastrar
                </Button>
              </GridItem>
            </GridContainer>
          </form>
        </Paper>
      </Container>
    </>
  );
}
